export const PRODUCT_FEEDBACK_REQUEST_SUPERSEDED = 'superseded' as const;
